// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Vector51Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 470 547"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        opacity={".25"}
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M263.752.944C345.751 5.66 422.201 56.417 450.84 153.525c32.956 111.746 25.415 243.311-48.379 317.744-84.373 85.104-203.944 104.256-292.339 25.926-92.59-82.048-135.654-235.689-94.477-368.699C51.581 12.418 165.13-4.728 263.752.944z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Vector51Icon
/* prettier-ignore-end */
